<template></template>
<script>
export default {
  props: {},
  data: function () {
    return {
      user: {},
    };
  },
  mounted: function () {
    this.user = Webservice.getUser().then((response) => {
      if (response.data) {
        this.user = response.data;
        this.watchSockets();
      }
    });
  },
  methods: {
    watchSockets() {
      window.Echo.channel(`customer.${SITEKEY}.${this.user.id}`).listen(
        ".ticket-update",
        (e) => {
          this.$emit("ticket-update");
          if (e.ticket_message == "replied") {
            this.$notify({
              component: {
                template:
                  "<span>" + this.$t("ticket_replied_view_tickets") + "</span>",
              },
              icon: "fas fa-lightbulb",
              horizontalAlign: "center",
              verticalAlign: "top",
              type: "success",
              timeout: 18000,
            });

            var audio = new Audio("/static/notification.mp3");
            audio.play();
            return;
          }
          return;
        }
      );
      window.Echo.channel(`customer.${SITEKEY}.${this.user.id}`).listen(
        ".file-update",
        (e) => {
          this.$emit("file-update");
          this.$notify({
            component: {
              template: "<span>" + this.$t("file_update_detected") + "</span>",
            },
            icon: "fas fa-lightbulb",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success",
            timeout: 18000,
          });

          var audio = new Audio("/static/notification.mp3");
          audio.play();
          return;
        }
      );
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/components/SocketListener.vue